import React from 'react';
import { Space, Typography } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { getPasswordPolicyChecks } from '@seaters/constants';
import { baseColor400, successColor } from '../theme/colors';
const { Text } = Typography;

export const PasswordValidation = ({ password }: { password: string }) => {
  const { t } = useTranslation();
  const passwordPolicyChecks = getPasswordPolicyChecks(password);

  return (
    <Space
      direction="vertical"
      size={8}
      style={{ marginBottom: 24, width: '100%' }}
    >
      <Space direction="vertical" size={4} style={{ width: '100%' }}>
        {passwordPolicyChecks.map((check) => (
          <Space key={check.key} align="start" size={8}>
            {check.isSatisfied ? (
              <CheckOutlined style={{ color: successColor, marginTop: 4 }} />
            ) : (
              <CloseOutlined style={{ color: baseColor400, marginTop: 4 }} />
            )}
            <Text
              style={{
                color: check.isSatisfied ? successColor : baseColor400,
              }}
            >
              {t(check.label, check.params)}
            </Text>
          </Space>
        ))}
      </Space>
    </Space>
  );
};
